<template>
  <div>
    <v-container fluid>
      <div>
        <div style="float: left">
          <v-dialog v-model="dialogSearch" max-width="500px" height="600px">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="primary" depressed>
                <span class="material-icons">search</span>
                search
              </v-btn>
            </template>
            <v-card v-if="dialogSearch">
              <div style="float: right">
                <v-btn @click="dialogSearchClose" icon>
                  <span class="material-icons">close</span>
                </v-btn>
              </div>
              <v-card-title class="title">Search</v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="form-control">
                      <label>ชื่อ</label>
                      <input placeholder="Name" type="text" v-model="searchinput.name" />
                    </div>
                  </v-flex>
                  <v-flex xs6 pr-1>
                    <div class="form-control">
                      <label>ประเภทรถ</label>
                      <input placeholder="Type" type="text" v-model="searchinput.type" />
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="form-control">
                      <label>สถานะ</label>
                      <multiselect
                        v-model="searchinput.status"
                        :options="statusOptions"
                        selectLabel
                        selectedLabel
                        :searchable="false"
                        deselect-label
                        open-direction="bottom"
                      ></multiselect>
                      <!-- <v-overflow-btn
                        :items="dropdown_font"
                        label="Overflow Btn"
                        target="#dropdown-example"
                      ></v-overflow-btn>-->
                    </div>
                  </v-flex>
                  <v-flex xs6 pr-1>
                    <v-menu
                      ref="showStartDate"
                      v-model="showStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <v-layout>
                          <v-flex>
                            <div class="form-control">
                              <label>วันเวลาที่ต้องการเช่า(เริ่ม)</label>
                              <input
                                placeholder="dd/mm/yyyy"
                                type="text"
                                name
                                v-model="filteredStartDate"
                                v-on="on"
                                readonly
                              />
                            </div>
                          </v-flex>
                          <v-flex>
                            <v-btn
                              fab
                              flat
                              small
                              class="my-0"
                              @click="searchinput.startdate = null"
                            >
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="searchinput.startdate"
                        @input="showStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6>
                    <v-menu
                      ref="showEndDate"
                      v-model="showEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <v-layout>
                          <v-flex class="form-control">
                            <label>วันเวลาที่ต้องการเช่า(สิ้นสุด)</label>
                            <input
                              placeholder="dd/mm/yyyy"
                              type="text"
                              name
                              v-model="filteredEndDate"
                              v-on="on"
                              readonly
                            />
                          </v-flex>
                          <v-flex>
                            <v-btn fab flat small class="my-0" @click="searchinput.enddate = null">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="searchinput.enddate"
                        @input="showEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <div>
                  <v-btn depressed color="primary" @click="onSearch" block>Search</v-btn>
                </div>
                <div>
                  <v-btn color="primary" @click="clearSearch" block outline>Clear search</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
        <div style="float: right">
          <v-btn @click="getscgallrentcustomers" color="primary" icon>
            <span class="material-icons">refresh</span>
          </v-btn>
        </div>
      </div>
      <v-pagination
        @input="changepage"
        v-model="page"
        :length="pagelength"
        :total-visible="7"
      ></v-pagination>
      <v-data-table
        expand
        hide-actions
        :loading="loading"
        :headers="headers"
        :items="filteredDesserts"
        class="elevation-1 scgallrenttable"
      >
        <template v-slot:items="props">
          <tr @click.stop="showHistory(props.item)" style="cursor: pointer">
            <td class="text-xs-center" @click="linkUserInbox(props.item.userid)">
              <v-avatar size="30">
                <img
                  v-if="props.item.profile_pic"
                  :src="props.item.profile_pic"
                  width="30"
                  height="30"
                  :alt="props.item.first_name"
                />
                <img
                  v-else
                  :src="'/static/img/assets/livechat/profile.png'"
                  width="30"
                  height="30"
                  :alt="props.item.first_name"
                />
              </v-avatar>
            </td>

            <td class="text-xs-center">{{ props.item.first_name }}</td>
            <td style="padding: 0px" class="text-xs-center">{{ props.item.type }}</td>
            <td style="padding: 0px" class="text-xs-center">
              <v-btn
                :color="$options.filters.statusColor(props.item.status)"
                depressed
                style="border-radius: 20px; color: white"
                small
                @click.stop="showDialog(props.item.id)"
                rounded="true"
                >{{ props.item.status }}</v-btn
              >
            </td>
            <td class="text-xs-center">
              {{ props.item.quotation_amount ? props.item.quotation_amount : '-' }}
            </td>
            <td class="text-xs-center">
              {{ props.item.invoice_amount ? props.item.invoice_amount : '-' }}
            </td>
            <td class="text-xs-center" style="white-space: nowrap">
              {{ props.item.start_date | dateFormat('DD/MM/YYYY') }} -
              {{ props.item.end_date | dateFormat('DD/MM/YYYY') }}
            </td>
            <td>{{ props.item.create_timestamp | dateFormat('DD/MM/YYYY') }}</td>
            <td class="text-xs-center">{{ props.item.contact }}</td>
            <td style="white-space: nowrap" class="text-xs-center">
              <p
                :style="`color: ${$vuetify.theme.primary}`"
                v-if="props.item.location.startsWith('https://www.google.com/maps')"
                @click.stop="gotoGoogle(props.item.location)"
              >
                GoogleMap
              </p>

              <div v-else>{{ props.item.location }}</div>
            </td>

            <td class="text-xs-center">{{ props.item.company }}</td>
            <td class="text-xs-right">{{ props.item.supplier ? props.item.supplier : '-' }}</td>
            <td class="text-xs-center remark">
              {{ props.item.remark }}
              <span
                @click.stop="editremark(props.item.remark, props.item.id)"
                :style="`color: ${$vuetify.theme.primary}; cursor: pointer;font-size: 15px`"
                class="material-icons"
                >create</span
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px" height="600px">
          <v-card v-if="dialog">
            <v-card-title>
              <h5>Send Status Message</h5>
            </v-card-title>
            <v-card-text>
              <div>
                <v-layout wrap>
                  <v-flex xs12 xm12 md12>
                    <div>
                      <label>อัพโหลดใบวางบิล/ ใบเสนอราคา</label>
                      <uploadfile v-model="input.image_url"></uploadfile>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <div class="form-control">
                      <label>Message</label>
                      <input
                        maxlength="640"
                        v-model="input.message"
                        type="text"
                        style="margin: 0"
                      />
                      <div style="text-align: right; font-size: 11px">
                        {{ input.message.length }}/640
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <div class="form-control" style="z-index: 999">
                      <label>Status</label>
                      <multiselect
                        v-model="input.status"
                        :options="statusOptions"
                        selectLabel
                        selectedLabel
                        :searchable="false"
                        deselect-label
                      ></multiselect>
                    </div>
                  </v-flex>
                  <v-flex v-if="input.status == 'รอจ่ายเงิน'" xs12 sm12 md12>
                    <div class="form-control">
                      <label>Amount</label>
                      <input v-model="input.amount" type="number" step="0.1" style="margin: 0" />
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="close">Close</v-btn>
              <v-btn color="primary" :loading="sendloading" flat @click.native="sendStatus(dialog)"
                >Send</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogremark" persistent max-width="500px">
          <v-card>
            <v-card-text>
              <div class="form-control">
                <label>Remark</label>
                <input type="text" v-model="input.remark" />
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div>
                <v-btn color="primary" flat @click="dialogremark = false">CANCEL</v-btn>
                <v-btn
                  color="primary"
                  :loading="remarkloading"
                  :disabled="remarkloading"
                  @click="saveremark(input.remark, currentremarkid)"
                  flat
                  >SAVE</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="historydialog" persistent max-width="1000px" height="600px">
          <v-card v-if="historydialog">
            <v-card-title>
              <h5>Transaction History</h5>
            </v-card-title>
            <v-card-text>
              <div>
                <v-data-table
                  v-bind:pagination.sync="pagination"
                  :headers="historyheaders"
                  :items="dialogHistoryData"
                  class="elevation-1"
                  hide-actions
                  :loading="historyloading"
                >
                  <template v-slot:items="props">
                    <tr>
                      <td class="text-xs-center pa-3">
                        <div
                          style="cursor: pointer"
                          @click="showPayslipImage(props.item.image_url, 'url')"
                        >
                          <v-img
                            v-if="/(\.pdf$)/.test(props.item.image_url)"
                            width="140px"
                            src="/static/img/pdf-image-placeholder.94190da.png"
                          ></v-img>
                          <v-img v-else width="140px" :src="props.item.image_url"></v-img>
                        </div>
                      </td>
                      <td class="text-xs-center">
                        <div>{{ props.item.status }}</div>
                      </td>
                      <td class="text-xs-center">
                        <div>{{ props.item.message ? props.item.message : '-' }}</div>
                      </td>
                      <td class="text-xs-center">
                        <div>{{ props.item.transactionid ? props.item.transactionid : '-' }}</div>
                      </td>
                      <!-- <td class="text-xs-center">
                        <div
                          v-if="props.item.payslip"
                          @click="showPayslipImage(props.item.payslip, 'base64')"
                          :style="`font-weight: 600;color: ${$vuetify.theme.primary};cursor: pointer`"
                        >
                          <span class="material-icons">image</span>
                        </div>
                        <div v-else>-</div>
                      </td>-->
                      <td class="text-xs-center pa-3">
                        <div
                          v-if="props.item.payslip"
                          @click="showPayslipImage(props.item.payslip, 'base64')"
                        >
                          <v-img width="140px" :src="props.item.payslip"></v-img>
                        </div>
                        <div v-else>-</div>
                      </td>
                      <td class="text-xs-center">
                        <div>{{ props.item.timestamp | dateFormat('DD/MM/YYYY HH:mm') }}</div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="closehistory">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    Multiselect,
    uploadfile,
  },
  data() {
    return {
      limit: 10,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 0,
      remarkloading: false,
      dialogremark: false,
      currentremarkid: '',
      sendloading: false,
      dialogSearch: '',
      search: {
        name: '',
        type: '',
        status: '',
        startdate: '',
        enddate: '',
      },
      searchinput: {
        name: '',
        type: '',
        status: '',
        startdate: '',
        enddate: '',
      },
      showStartDate: false,
      showEndDate: false,
      dialog: false,
      dialogData: '',
      loading: true,
      historydialog: false,
      dialogHistoryData: [],
      historyloading: false,
      statusOptions: [
        'Reject',
        'ส่งใบเสนอราคา',
        'รอจ่ายเงิน',
        'จ่ายเงินแล้ว',
        'ตกลงจอง',
        'Completed',
        'Review',
      ],
      input: {
        status: '',
        message: '',
        image_url: '',
        remark: '',
        amount: '',
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'ชื่อ', value: 'first_name', align: 'center', width: '1%' },
        { text: 'ประเภทรถ', value: 'type', align: 'center', width: '1%' },
        { text: 'สถานะ', value: 'status', align: 'center', width: '1%' },
        { text: 'ราคาเสนอ', value: 'quotation_amount', align: 'center', width: '1%' },
        { text: 'ราคาซื้อ', value: 'invoice_amount', align: 'center', width: '1%' },
        { text: 'วันที่ต้องการเช่า', value: 'start_date', align: 'center', width: '1%' },
        { text: 'วันที่ลงทะเบียน', value: 'start_date', align: 'center', width: '1%' },
        { text: 'ข้อมูลติดต่อ', value: 'contact', align: 'center', width: '1%' },
        { text: 'สถานที่', value: 'location', align: 'center', width: '1%' },
        { text: 'บริษัท', value: 'company', align: 'center', width: '1%' },
        { text: 'Supplier ที่ทำงาน', value: 'supplier', align: 'center', width: '1%' },
        { text: 'Remark', value: 'remark', align: 'center', width: '1%' },
      ],
      historyheaders: [
        { text: '', value: '' },
        { text: 'Status', value: 'status', align: 'center' },
        { text: 'Message', value: 'message', align: 'center' },
        { text: 'Transaction id', value: 'transactionid', align: 'center' },
        { text: 'Payslip', value: 'payslip', align: 'center' },
        { text: 'Time', value: 'time', align: 'center' },
      ],
      desserts: [],
    }
  },
  computed: {
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot']),
    filteredDesserts() {
      var result = [...this.desserts]

      if (this.search.name) {
        result = result.filter((el) => el.first_name.includes(this.search.name))
      }
      if (this.search.type) {
        result = result.filter((el) => el.type.includes(this.search.type))
      }
      if (this.search.status) {
        result = result.filter((el) => el.status.includes(this.search.status))
      }
      if (this.search.startdate) {
        result = result.filter((el) => {
          return (
            moment(el.start_date.split('/').reverse().join('/')).diff(
              moment(this.search.startdate)
            ) >= 0
          )
        })
      }
      if (this.search.enddate) {
        result = result.filter((el) => {
          return (
            moment(el.end_date.split('/').reverse().join('/')).diff(moment(this.search.enddate)) <=
            0
          )
        })
      }

      return result
    },
    filteredStartDate() {
      if (this.searchinput.startdate) {
        return moment(this.searchinput.startdate).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    filteredEndDate() {
      if (this.searchinput.enddate) {
        return moment(this.searchinput.enddate).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
  },
  mounted() {
    this.getscgallrentcustomers(this.limit, this.offset)
    setInterval(() => {
      this.getscgallrentcustomers(this.limit, this.offset)
    }, 30000)
  },
  methods: {
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.getscgallrentcustomers(this.limit, this.offset)
      }
    },
    linkUserInbox(userid) {
      let routeData = this.$router.resolve({ name: 'livechat', query: { userid } })
      window.open(routeData.href, '_blank')
      // this.$router.push({ name: 'livechat', params: { userid } })
    },
    editremark(val, id) {
      this.input.remark = val
      this.currentremarkid = id
      this.dialogremark = true
    },
    saveremark(remark, id) {
      this.remarkloading = true
      api.scgallrentupdateremark({ remark, id }, (err, response) => {
        this.remarkloading = false
        if (response.responsecode == 200) {
          this.desserts.find((el) => el.id == id).remark = remark
          this.dialogremark = false
        }
      })
    },
    showPayslipImage(url, type) {
      // window.location.href = url
      if (url) {
        if (type == 'base64') {
          var image = new Image()
          image.src = 'data:image/jpg;base64,' + url

          var w = window.open('')
          w.document.write(image.outerHTML)
        } else {
          window.open(url, '_blank')
        }
      }
    },
    gotoGoogle(url) {
      window.location.href = url
    },
    clearSearch() {
      var emptySearch = {
        name: '',
        type: '',
        status: '',
        startdate: '',
        enddate: '',
      }
      this.search = { ...emptySearch }
      this.searchinput = { ...emptySearch }
      this.dialogSearch = false
    },
    onSearch() {
      this.search = { ...this.searchinput }
      this.dialogSearch = false
    },
    dialogSearchClose() {
      this.dialogSearch = false
    },
    showDialog(id) {
      this.dialog = true
      this.dialogData = id
      this.input.status = this.desserts.find((el) => el.id == id).status
    },
    closehistory() {
      this.historydialog = false
      this.dialogHistoryData = []
    },
    close() {
      this.input = {
        status: '',
        message: '',
        image_url: '',
      }
      this.dialog = false
    },
    showHistory(id) {
      // console.log(id)
      this.historydialog = true
      this.historyloading = true
      api.getscgallrenthistory(id, (err, response) => {
        this.historyloading = false
        if (response.responsecode == 200) {
          this.dialogHistoryData = response.data
        }
      })
    },
    sendStatus(id) {
      this.sendloading = true
      var vm = this
      var user = vm.desserts.find((el) => el.id == this.dialogData)
      var data = {
        id: this.dialogData,
        status: vm.input.status,
        amount: vm.input.amount,
        message: vm.input.message,
        image_url: vm.input.image_url,
        userid: user.userid,
        pageid: vm.selectedBot.pageid,
      }
      api.putscgallrentchangestatus(data, (error, response) => {
        this.sendloading = false
        if (response.responsecode == 200) {
          vm.$swal
            .fire({
              type: 'success',
              text: 'Status sended',
            })
            .then(() => {
              this.desserts.find((el) => el.id == this.dialogData).status = vm.input.status
              vm.close()
            })
        }
      })
    },
    getscgallrentcustomers(limit, offset) {
      var vm = this
      this.loading = true
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      api.getscgallrentcustomers(
        { pageid: this.selectedBot.pageid, limit, offset },
        (error, response) => {
          if (response.responsecode == 200) {
            this.loading = false
            if (response.data) {
              vm.desserts = response.data
              vm.pagetotal = parseInt(vm.desserts[0].total)
            } else {
              vm.desserts = []
            }
          }
        }
      )
    },
  },
  filters: {
    statusColor: function (value) {
      var color
      switch (value) {
        case 'Waiting':
          color = 'grey'
          break
        case 'Reject':
          color = '#FF6347'
          break
        case 'ส่งใบเสนอราคา':
          color = '#A52A2A'
          break
        case 'รอจ่ายเงิน':
          color = '#663399'
          break
        case 'จ่ายเงินแล้ว':
          color = 'green'
          break
        case 'ตกลงจอง':
          color = '#228B22'
          break
        case 'Completed':
          color = '#FFD700'
          break
        case 'Review':
          color = '#20B2AA'
          break

        default:
          color = 'grey'
          break
      }
      return color
    },
  },
}
</script>

<style>
/* .scgallrenttable .v-table__overflow .v-datatable.v-table.theme--light thead tr th {
  padding: 0 !important;
  text-align: center;
} */
</style>


// WEBPACK FOOTER //
// src/components/view/template/scgallrent/customerCRM.vue